import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'retailers-opt_in_nudge_expandcollapse-click';
/**
 * Track user clicks of the expand and collapse of the popup prompt nudge, for opt-in nudges. The "Action" parameter below will return either "COLLAPSE" or "EXPAND".
 */ export function trackRetailersOptInNudgeExpandcollapseClick(Action_string) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            Action_string: Action_string
        }
    });
}
